export class Ferramenta {
  constructor({
    unidadeId,
    uuid,
    nome,
    descricao,
    imagem,
    grupo,
    serie,
    patrimonio,
    fornecedorId,
    documento,
    preco,
    responsavelId,
    responsavelNome,
    origem,
    permanencia,
    status,
    dataPrevista,
    dataRetirada,
    dataEntrega,
    checklist,
    movimentacao_uuid,
    url,
  }) {
    this.unidadeId = unidadeId;
    this.uuid = uuid;
    this.nome = nome;
    this.descricao = descricao;
    this.imagem = imagem;
    this.grupo = grupo;
    this.serie = serie;
    this.patrimonio = patrimonio;
    this.fornecedorId = fornecedorId;
    this.documento = documento;
    this.preco = preco;
    this.responsavelId = responsavelId;
    this.responsavelNome = responsavelNome;
    this.origem = origem;
    this.permanencia = permanencia;
    this.status = status;
    this.dataPrevista = dataPrevista;
    this.dataRetirada = dataRetirada;
    this.dataEntrega = dataEntrega;
    this.checklist = checklist;
    this.movimentacao_uuid = movimentacao_uuid;
    this.url = url;
  }
}
